<div class="container">
    <div class="row">
        <mat-form-field class="col-md-5" appearance="outline">
            <mat-label>Enter a date range</mat-label>
            <mat-date-range-input  [rangePicker]="picker">
                <input matStartDate [(ngModel)]="startDate" placeholder="Start date">
                <input matEndDate [(ngModel)]="endDate" placeholder="End date">
            </mat-date-range-input>
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-date-range-picker #picker></mat-date-range-picker>

        </mat-form-field>
    <button mat-mini-fab color="accent"> <mat-icon>search</mat-icon> </button>
    </div>

</div>
